import { ICreativeFormData } from '@/Interfaces/Creatives/Creative.interface';
import ModalTitleCard from '@/components/Modal/common/ModalTitleCard';
import PixelsInput from '@/pages/CreativeLibrary/Modals/components/PixelsInput';
import { Button, Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

interface IProps {
  open: boolean;
  onClose: () => void;
  pixels: string[];
  onSubmit?: (pixels: string[]) => void;
  disabled?: boolean;
}

const PixelsModal = ({ open, onClose, pixels, onSubmit, disabled }: IProps) => {
  const formMethods = useForm<ICreativeFormData>({
    defaultValues: {
      pixels: pixels ?? [],
    },
  });

  const { handleSubmit, reset } = formMethods;

  const handleClose = () => {
    reset();
    onClose();
  };

  const submitHandler = (data: ICreativeFormData) => {
    if (disabled || !onSubmit) return;

    onSubmit(data.pixels);
    handleClose();
  };

  useEffect(() => {
    if (open) {
      reset({ pixels });
    }
  }, [open, pixels, reset]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <DialogContent>
        <ModalTitleCard title='Edit Creative 3rd Party Pixels' handleClose={handleClose} />

        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(submitHandler)} className='mt-4 space-y-4'>
            <PixelsInput
              pixels={formMethods.watch('pixels')}
              handlePixelsChange={pixels => formMethods.setValue('pixels', pixels, { shouldDirty: true })}
              control={formMethods.control}
              disabled={disabled}
            />

            <div className='flex justify-end gap-2 pt-4'>
              <Button variant='outlined' onClick={handleClose}>
                Cancel
              </Button>
              {!disabled && (
                <Button type='submit' variant='contained'>
                  Save
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

export default PixelsModal;
